"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSearchByValue = void 0;
var apps_shared_1 = require("@l2p/apps-shared");
var game_api_1 = require("@l2p/game-api");
var swr_hooks_1 = require("@l2p/swr-hooks");
var react_1 = require("react");
var SEARCH_TITLE = 'search_title';
var IS_SEARCH_ACTIVE = 'is_search_active';
var GAMES_SEARCH_RESULT = 'games_search_results';
var useSearchByValue = function (_a) {
    var _b, _c, _d;
    var _e = _a === void 0 ? {} : _a, _f = _e.id, id = _f === void 0 ? null : _f;
    var activeFilterId = id;
    var breakpoints = (0, apps_shared_1.useBreakpoint)();
    var _g = (0, swr_hooks_1.useCache)(), getDataFromCache = _g.getDataFromCache, setDataToCache = _g.setDataToCache;
    var _h = (0, react_1.useState)(getDataFromCache(SEARCH_TITLE) || ''), searchValue = _h[0], setSearchValue = _h[1];
    var _j = (0, react_1.useState)(getDataFromCache(IS_SEARCH_ACTIVE) || false), isSearchActive = _j[0], setSearchActive = _j[1];
    var currentCurrency = (0, swr_hooks_1.useCurrentCurrency)();
    var prevSearch = (0, react_1.useRef)(searchValue);
    var prevFilterId = (0, react_1.useRef)(activeFilterId);
    var prevCurrency = (0, react_1.useRef)(currentCurrency);
    var searchTimer = (0, react_1.useRef)(null);
    var _k = (0, swr_hooks_1.useSearchGames)({
        successAction: function (results) {
            setDataToCache(GAMES_SEARCH_RESULT, results);
        },
    }), searchGames = _k.searchGames, data = _k.data, isSubmitting = _k.isSubmitting;
    var geoData = (0, swr_hooks_1.useGeo)().data;
    (0, react_1.useEffect)(function () {
        var searchValueChanged = prevSearch.current !== searchValue;
        var shouldSkip = prevSearch.current === searchValue &&
            prevFilterId.current === activeFilterId &&
            prevCurrency.current === currentCurrency;
        if (shouldSkip)
            return;
        var delay = searchValueChanged ? 200 : 0;
        searchTimer.current = setTimeout(function () {
            var _a, _b;
            searchGames({
                page: 0,
                limit: 1000,
                filter: {
                    devices: [
                        breakpoints.mobile || breakpoints.tablet
                            ? game_api_1.GameDeviceTypeEnum.Mobile
                            : game_api_1.GameDeviceTypeEnum.Desktop,
                        game_api_1.GameDeviceTypeEnum.Universal,
                    ],
                    title: searchValue ? searchValue : undefined,
                    categoryId: activeFilterId ? activeFilterId : undefined,
                    allowedCountries: ((_a = geoData === null || geoData === void 0 ? void 0 : geoData.geoData) === null || _a === void 0 ? void 0 : _a.countryCode)
                        ? [(_b = geoData === null || geoData === void 0 ? void 0 : geoData.geoData) === null || _b === void 0 ? void 0 : _b.countryCode]
                        : undefined,
                    currencies: currentCurrency ? [currentCurrency] : undefined,
                },
            });
        }, delay);
        prevSearch.current = searchValue;
        prevFilterId.current = activeFilterId;
        prevCurrency.current = currentCurrency;
        return function () {
            if (searchTimer.current)
                clearTimeout(searchTimer.current);
        };
    }, [
        breakpoints,
        (_b = geoData === null || geoData === void 0 ? void 0 : geoData.geoData) === null || _b === void 0 ? void 0 : _b.countryCode,
        searchGames,
        searchValue,
        activeFilterId,
        currentCurrency,
    ]);
    var cachedResults = getDataFromCache(GAMES_SEARCH_RESULT);
    var gamesToShow = ((_c = cachedResults === null || cachedResults === void 0 ? void 0 : cachedResults.data) === null || _c === void 0 ? void 0 : _c.edges) || ((_d = data === null || data === void 0 ? void 0 : data.data) === null || _d === void 0 ? void 0 : _d.edges) || [];
    (0, react_1.useEffect)(function () {
        if (!isSearchActive && !isSubmitting) {
            setSearchActive(true);
            setDataToCache(IS_SEARCH_ACTIVE, true);
        }
    }, [isSearchActive, isSubmitting, setDataToCache]);
    var handleSearchInputClear = (0, react_1.useCallback)(function () {
        setSearchValue('');
        setDataToCache(SEARCH_TITLE, '');
    }, [setDataToCache]);
    var handleSearchInputChange = (0, react_1.useCallback)(function (event) {
        setSearchValue(event.currentTarget.value);
        setDataToCache(SEARCH_TITLE, event.currentTarget.value);
    }, [setDataToCache]);
    return {
        isSubmitting: isSubmitting,
        games: gamesToShow,
        searchValue: searchValue,
        isSearchActive: isSearchActive,
        handleSearchInputChange: handleSearchInputChange,
        handleSearchInputClear: handleSearchInputClear,
    };
};
exports.useSearchByValue = useSearchByValue;
exports.default = exports.useSearchByValue;
